import { isNull, omit, omitBy } from 'lodash';

export const createDDBItem = (data: any) => {
  const withoutNullValues = omitBy(data, isNull);
  return {
    ...omit(withoutNullValues, ['updated_at']),
    price: withoutNullValues.price.replace(',', '.'),
  };
};
